import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MotionVideo from '../components/motion/MotionVideo';
import { motionVideos } from '../data/motion';

export default function Motion() {
  const featured = motionVideos.find((v) => v.featured) ?? motionVideos[0];

  return (
    <div className="flex flex-col px-4 sm:px-8 md:px-16 lg:px-32 xl:px-[200px] 2xl:px-[250px] pt-[9vh] md:pt-[14vh]">
      <Link
        to="/motion"
        className="group flex flex-col lg:flex-row rounded-2xl border border-gray-200 overflow-hidden"
      >
        {/* Video */}
        <div className="w-full lg:w-[55%] aspect-video lg:aspect-auto lg:min-h-[360px]">
          {featured ? (
            <MotionVideo
              src={featured.src}
              poster={featured.poster}
              title={featured.title}
              className="w-full h-full"
            />
          ) : (
            <div className="w-full h-full min-h-[200px] bg-gradient-to-br from-yellow-500 via-yellow-600 to-black" />
          )}
        </div>

        {/* Text */}
        <div className="flex flex-col justify-center gap-4 md:gap-5 w-full lg:w-[45%] p-6 md:p-10 lg:p-12">
          <p className="font-poppins font-semibold text-[12px] md:text-[13px] uppercase tracking-[0.2em] text-yellow-600">
            Motion
          </p>
          <h2
            className="font-poppins font-bold text-[28px] md:text-[36px] lg:text-[40px] leading-[36px] md:leading-[44px] lg:leading-[48px] text-black"
            style={{ letterSpacing: '-0.4px' }}
          >
            Code moves things.
            <br />
            So do I.
          </h2>
          <p className="font-poppins font-normal text-[14px] md:text-[16px] leading-[22px] md:leading-[26px] text-gray-700">
            Experiments in motion design: timing, easing, and making pixels feel alive.
          </p>
          <span className="inline-flex items-center gap-2 font-poppins font-semibold text-[15px] md:text-[17px] text-black pt-2">
            Watch the reel
            <ArrowForwardIcon
              className="transition-transform duration-300 group-hover:translate-x-2"
              style={{ fontSize: '22px' }}
            />
          </span>
        </div>
      </Link>
    </div>
  );
}
